import { getActiveBrandPrimaryColor, getDateFormat } from '../../../../infra/session';
import { canUseSmsChannel } from '../utils/delivery-channels';
export var buildInitialState = function (params) {
    var defaultState = {
        id: null,
        canEdit: true,
        isNewCampaign: true,
        isInitialized: false,
        isProcessing: false,
        isDraft: false,
        editableFields: {
            type: { value: null },
            promoId: { value: null },
            usesCustomAudiences: { value: false },
            displayName: { value: '' },
            audiences: {
                value: {
                    newClients: {
                        enabled: false,
                    },
                    service: {
                        enabled: false,
                        serviceId: null,
                    },
                    lapsing: {
                        enabled: false,
                    },
                    regular: {
                        enabled: false,
                    },
                    prospective: {
                        enabled: false,
                    },
                    barbers: {},
                    shops: {},
                },
            },
            usesCustomSchedule: { value: false },
            frequency: { value: null },
            sendTime: { value: null },
            sendDate: { value: null },
            endDate: { value: null },
            dayOfWeek: { value: null },
            dayOfMonth: { value: null },
            usesCustomDeliveryChannels: { value: false },
            sendSms: { value: true },
            sendEmail: { value: true },
            sendPush: { value: true },
            emailSubject: { value: null },
            emailSubjectLimit: { value: null },
            emailTitle: { value: null },
            emailTitleLimit: { value: null },
            emailBody: { value: null },
            emailBodyLimit: { value: null },
            emailCoverImage: { value: null },
            emailLogoImage: { value: null },
            pushTitle: { value: '' },
            smsBodySuffix: { value: '' },
            pushBody: { value: null },
            pushBodyLimit: { value: null },
            smsBody: { value: null },
            smsBodyLimit: { value: null },
            ctaColor: { value: null },
            dateFormat: { value: 'MM/DD/YYYY' },
        },
    };
    if (!(params === null || params === void 0 ? void 0 : params.session)) {
        return defaultState;
    }
    defaultState.editableFields.ctaColor.value = getActiveBrandPrimaryColor(params.session) || null;
    defaultState.editableFields.dateFormat.value = getDateFormat(params.session);
    var isSmsChannelEnabled = canUseSmsChannel({ session: params.session });
    if (!isSmsChannelEnabled) {
        defaultState.editableFields.sendSms.value = false;
        defaultState.editableFields.usesCustomDeliveryChannels.value = true;
    }
    return defaultState;
};
